import React, { useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setIsSidebarOpen } from "context/features/dataSlice";
import News from "features/News";
import BookmarkDrawer from "features/Bookmarks";
import SourceSidebar from "features/SourceInfo";
import { useSourceData } from "features/SourceInfo/hooks/use-source-data.hooks";
import { Helmet } from "react-helmet-async";
import { useSourceSearch } from "features/SourceSearch";

const Newspage = () => {
  const { isSidebarOpen } = useSelector((state) => state.data);
  const { isSourceSidebarOpen } = useSourceData();
  const { currentSearchTerm } = useSourceSearch();

  const dispatch = useDispatch();
  const anyOpen = isSidebarOpen || isSourceSidebarOpen;

  const sidebarClosedHandler = () => {
    dispatch(setIsSidebarOpen(false));
    document.body.style.overflow = "unset";
  };

  const showSidebar = () => {
    dispatch(setIsSidebarOpen(true));
  };

  useEffect(() => {
    if (anyOpen) {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
  }, [anyOpen]);

  return (
    <Fragment>
      <Helmet>
        <title>Sooth - Search for '{currentSearchTerm}'</title>
      </Helmet>
      <News />
      <BookmarkDrawer
        isSidebarOpen={isSidebarOpen}
        sidebarClosedHandler={sidebarClosedHandler}
        showSidebar={showSidebar}
      />

      <SourceSidebar />
    </Fragment>
  );
};

export default Newspage;
